import type { PropsWithChildren } from 'react';
import {
  CancelConfirmActions,
  type CancelConfirmActionsProps,
} from '../../buttons/CancelConfirmActions';
import {
  RegularDialog,
  type RegularDialogProps,
} from '../RegularDialog/RegularDialog';

/**
 * Full confirm dialog: `RegularDialog` shell with cancel/confirm actions in a
 * fixed footer. Use when the modal owns title, content, and action buttons.
 *
 * For button-only footers inside an existing dialog shell, use
 * `CancelConfirmActions` instead.
 */
export type CancelConfirmDialogProps = PropsWithChildren<
  Omit<RegularDialogProps, 'actions' | 'sx'> & CancelConfirmActionsProps
>;

const dialogActionsSx = {
  mt: 0,
  width: '100%',
};

export const CancelConfirmDialog = ({
  cancelText,
  confirmText,
  onClickCancel,
  onClickConfirm,
  onLoadingConfirm,
  disabledConfirm,
  confirmColor,
  confirmVariant,
  sx,
  children,
  ...dialogProps
}: CancelConfirmDialogProps) => (
  <RegularDialog
    {...dialogProps}
    actions={
      <CancelConfirmActions
        cancelText={cancelText}
        confirmText={confirmText}
        onClickCancel={onClickCancel}
        onClickConfirm={onClickConfirm}
        onLoadingConfirm={onLoadingConfirm}
        disabledConfirm={disabledConfirm}
        confirmColor={confirmColor}
        confirmVariant={confirmVariant}
        sx={[dialogActionsSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
      />
    }
  >
    {children}
  </RegularDialog>
);
